import { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { ApiQueryExample } from "../types";
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { Button } from "~/components/ui/button";

// // // //

/**
 * ExamplesDropdown
 * Renders a dropdown for generating CSV + Excel exports
 */
export function ExamplesDropdown(props: {
    disabled: boolean;
    examples: Array<ApiQueryExample>;
    onSelectExample: (selectedQuery: ApiQueryExample) => void;
}) {
    const { examples, onSelectExample, disabled } = props;

    if (examples.length === 0) {
        return null;
    }

    return (
        <DropdownMenu>
            <Button
                asChild
                disabled={disabled}
                variant="outline"
                className="shadow-sm border-muted-foreground"
                size="xs"
            >
                <DropdownMenuTrigger disabled={disabled}>
                    <FontAwesomeIcon icon={faFolderOpen} aria-hidden="true" />
                    Example Filters
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className="ml-1"
                        aria-hidden="true"
                    />
                </DropdownMenuTrigger>
            </Button>
            <DropdownMenuContent className="w-120 z-200" align="end">
                {examples.map((each, index) => (
                    <Fragment key={each.key}>
                        {index > 0 && <DropdownMenuSeparator />}
                        <DropdownMenuItem
                            onClick={() => {
                                onSelectExample(each);
                            }}
                            className="flex flex-col items-start cursor-pointer focus:bg-slate-50"
                        >
                            <p className="font-normal text-sm">
                                {each.content.label}
                            </p>
                            {each.content.description && (
                                <p className="text-xs font-light mext-muted-foreground">
                                    {each.content.description}
                                </p>
                            )}
                        </DropdownMenuItem>
                    </Fragment>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
